<template>
  <div>
    <CModal
      :title="'Promotion For ' + titleName"
      :show="visible"
      @update:show="$emit('update:visible', $event)"
    >
      <div v-if="filteredPromotions.length">
        <label>
          It looks like this order qualifies for a running promotion! Select one and hit apply.
          If there’s only one, just click it and apply.
        </label>

        <div
          v-for="promo in filteredPromotions"
          :key="promo.id"
          class="promotion-option"
          :class="{ selected: selectedPromotion && selectedPromotion.id === promo.id }"
          @click="selectedPromotion = promo"
        >
          <input type="radio" :value="promo" v-model="selectedPromotion" style="margin-right: 10px;" />
          <strong>{{ promo.name }}</strong><br />
          <small>{{ promo.description }}</small>
        </div>
      </div>

      <div v-else>No applicable promotions for this order.</div>

      <template #footer>
        <CButton @click="close" color="danger">Cancel</CButton>
        <CButton @click="applyPromotion" color="success" :disabled="!selectedPromotion">Apply</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { getEligiblePromotionsForGroup } from './../../promotionUtils';

export default {
  name: 'PromotionPopup',
  props: {
    visible: { type: Boolean, default: false },
    group:   { type: Object, required: true },
    prebook: { default: null },
    onClose: { type: Function, required: true },
    onApply: { type: Function, required: true },
  },
  data() {
    return { selectedPromotion: null, filteredPromotions: [] };
  },
  computed: {
    titleName() {
      return (this.group?.program_info?.program_name || 'Program') + ' - ' + (this.group?.ship_date || '');
    },
  },
  watch: {
    group: {
      deep: true,
      handler() { this.refreshPromotions(); }
    },
    prebook: {
      deep: true,
      handler() { this.refreshPromotions(); }
    },
    visible(val) {
      // when opened, refresh
      if (val) this.refreshPromotions();
    }
  },
  methods: {
    refreshPromotions() { this.filteredPromotions = getEligiblePromotionsForGroup(this.group, this.prebook); },
    close() { this.selectedPromotion = null; this.$emit('update:visible', false); this.onClose(); },
    applyPromotion() { this.onApply(this.selectedPromotion); this.selectedPromotion = null; this.$emit('update:visible', false); },
  },
  mounted() { this.refreshPromotions(); },
};
</script>

<style scoped>
.promotion-option { padding:10px; border:1px solid #ccc; margin-bottom:10px; border-radius:5px; cursor:pointer; }
.promotion-option:hover { background:#f9f9f9; }
.promotion-option.selected { border-color:#28a745; box-shadow:0 0 0 2px rgba(40,167,69,.15); }
</style>
